var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6167 2.37182C19.8647 2.1135 20 1.78474 20 1.39726C20 0.622309 19.4138 8.9407e-08 18.6697 8.9407e-08C18.2976 8.9407e-08 17.9594 0.164384 17.7001 0.434442L9.98873 8.65362L2.29989 0.434442C2.04059 0.164384 1.69109 8.9407e-08 1.33033 8.9407e-08C0.586246 8.9407e-08 0 0.622309 0 1.39726C0 1.78474 0.135287 2.1135 0.383315 2.37182L8.95152 11.5068C9.24465 11.8356 9.60541 11.9883 10 12C10.3946 12 10.7328 11.8356 11.0372 11.5068L19.6167 2.37182Z",
    fill: "#696969",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGray);
export default __webpack_public_path__ + "static/media/arrow_gray.9ca65d3bcc6b4307a68ecf1d42fa47a4.svg";
export { ForwardRef as ReactComponent };